// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"b5c2860c","66":"27c5f07d","151":"916c1f47","237":"a9609da7","426":"b3b15963","508":"0e481734","515":"1bdb65c8","516":"d6d1aab3","582":"59b3ebd1","605":"29761504","638":"f31df64b","639":"75a14fe9","670":"3d36d5e2","761":"393f964f","813":"fbabb86a","948":"0d124cd6"}[chunkId] + ".chunk.js";
};